var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"nl2br",rawName:"v-nl2br",value:(_vm.request),expression:"request"}],class:_vm.classObj,attrs:{"title":"click to confirm"},on:{"click":function($event){_vm.checked = ! _vm.checked}}})
}
var staticRenderFns = []

export { render, staticRenderFns }